var _defs, _style, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAAXNSR0IB2cksfwAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAALSURBVHicY2DABwAAHgAB9v3plgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAAAXNSR0IB2cksfwAAADxQTFRFAAAAhYWVh4eTh4ePgICPh4qSh4qTiYuSiIqUiIyUiIqTiYmUh4mTiIuUh4uTiYuUiYmTiIqTiIyVioqPJcQc3wAAABR0Uk5TADBAIBBgkHCwn5BwgL9AcFCvnzCuB86uAAAAOElEQVR4nJ3H0RWAIAwDwJBSVKCocf9d5TECf3dAIi2TBLz4cV7utaHPRgCj7/J+kONdtCJ9Q5L9flgCyIWgo/wAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#img2",
    x: 0,
    y: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause1);
export default __webpack_public_path__ + "static/media/pause1.005d2bc6baccaa2f8373f2df48085873.svg";
export { ForwardRef as ReactComponent };